import { render } from "./PlanesDisponibles.vue?vue&type=template&id=224a1818&scoped=true"
import script from "./PlanesDisponibles.vue?vue&type=script&lang=js"
export * from "./PlanesDisponibles.vue?vue&type=script&lang=js"

import "./PlanesDisponibles.vue?vue&type=style&index=0&id=224a1818&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-224a1818"]])

export default __exports__